var render = function render(){var _vm=this,_c=_vm._self._c;return _c('general-config',{attrs:{"id":_vm.userInfo.id,"user-type":_vm.userInfo.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }